import React from "react"

const BoxDescription = ({description}) => (
    <p>{description}</p>
)

export default BoxDescription